import { render } from "./MultiWeekSelector.vue?vue&type=template&id=48ec6409&scoped=true"
import script from "./MultiWeekSelector.vue?vue&type=script&lang=js"
export * from "./MultiWeekSelector.vue?vue&type=script&lang=js"

import "./MultiWeekSelector.vue?vue&type=style&index=0&id=48ec6409&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ec6409"]])

export default __exports__